import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ConsentIntegrationOptions} from "../components/consentIntegrationSection/ConsentIntegrationSection";

export const consentMailchimpListCheck = async (domain: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `shop/validation-mailchimp-list`,
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain,
        isEncrypted: true,
    });
}